import { 
    SET_LOCALE
} from '../constants/action-types';

// LOCALIZATION

export const changeLocale = (language = 'ar') => ({
    type: SET_LOCALE,
    language
});